<template>
  <app-popup
    :show="showAdditionalInfo"
    @close="showAdditionalInfo = false"
  >
    <template #heading>
      <span class="headline--2">
        {{ element.lang.title }}
      </span>
    </template>
    <div>
      <template v-for="(setting, key) in settings">
        <app-input-dropdown
          v-if="typeof setting.settings.preview !== 'undefined' && setting.settings.preview"
          :key="'option' + key + 'in' + identifier"
          v-model="element.selection[setting.key]"
          :area="element"
          :element="setting"
          :identifier="'option' + key + 'in' + identifier"
        />
      </template>
      <template
        v-for="(setting, key) in settings"
        class="ed_element_fieldset well"
      >
        <fieldset
          v-if="typeof setting.settings.preview === 'undefined' || !setting.settings.preview"
          :key="'option' + key + 'in' + identifier"
          class="ed_element_fieldset well"
        >
          <legend class="ed_element_fieldset_legend">{{ setting.lang.title }} (keine Vorschau verfügbar):</legend>
          <ul style="font-size: 0.8rem; font-weight: bolder;">
            <li
              v-for="option in setting.settings.options"
              :key="'option' + option + 'inAppToolkitItemSetting' + key + 'in' + identifier"
            >{{ option }}</li>
          </ul>
        </fieldset>
      </template>
    </div>
    <hr>
    <div class="row">
      <div class="col-sm-8">
        <base-image
          additional-class="wireframe-img"
          :src="imgSrc"
        />
      </div>
      <div class="col-sm-4">
        <div v-html="element.lang['info_text']" />
        <br>
        <template v-if="typeof element.settings['examples'] !== 'undefined' && element.settings['examples'].length > 0">
          Optimal für
          <ul class="editor-list">
            <li v-for="example in element.settings['examples']" v-html="example"/>
          </ul>
        </template>
        <div>
          Du möchtest weitere Beispiele sehen oder weißt gerade nicht weiter? <a href="mailto:office@q2e.at">Eine Mail schreiben</a>
        </div>
      </div>
    </div>
  </app-popup>
  <base-panel
    additional-classes="panel--minimal"
    :modifier="showAdditionalInfo ? 'info' : 'default'"
  >
    <div
      class="handle"
      style="position: relative"
    >
      <base-image
        additional-class="wireframe-img wireframe-img--toolkit"
        :src="imgSrc"
        @mouseover="checkIfHoverable()"
      />
      <div
        v-if="hoverable"
        class="wireframe-screenshot-container"
      >
        <base-image
          additional-class="wireframe-screenshot"
          :src="imgSrcHover"
        />
      </div>
    </div>
    <button
      class="btn c-btn c-btn--no-arrow fa fa-plus tool app-toolkit--small item"
      title="Zur Idee hinzufügen"
      @click="$emit('add-element-manually', element)"
    ><span class="sr-only">Zur Idee hinzufügen</span></button>
    <template #footer>
      <div class="toolkit-item__title">
        <div class="footer-container">
          <small>{{ element.lang.title }}</small>
          <button
            class="btn fa fa-eye item"
            title="Detailansicht anzeigen"
            @click="showAdditionalInfo = true"
          ><span class="sr-only">Detailansicht anzeigen</span></button>
        </div>
      </div>
    </template>
  </base-panel>
</template>

<script>
import BasePanel from '@/components/BasePanel.vue';
import BaseButton from '@/components/BaseButton.vue';
import AppInputDropdown from '@/components/AppInputDropdown.vue';
import AppPopup from '@/components/AppPopup.vue';
import BaseImage from '@/components/BaseImage.vue';

/**
 * Die Komponente für die einzelnen Wireframes, inklusive der Vorschaubilder, Umschaltung, Infotext...
 * @displayName AppToolkitItem
 */
export default {
  name: 'AppToolkitItem',
  components: {
    BaseImage,
    AppPopup,
    BasePanel,
    BaseButton,
    AppInputDropdown
  },
  emits: ['add-element-manually'],
  props: {
    /**
     * Das konfigurierte Datenobjekt für das Feld das dargestellt werden soll
     */
    element: {
      type: Object,
      required: true
    },
    /**
     * Der Key des konfigurierten Datenobjekts für das Feld das dargestellt werden soll
     */
    identifier: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showAdditionalInfo: false,
      hoverable: false,
    }
  },
  computed: {
    settings() {
      let array = [];

      Object.keys(this.element.elements).forEach(key => {
        let element = this.element.elements[key];
        element.key = key;

        // this marks it as a setting (to be grouped at the top of the area)
        if (   element.type === 'dropdown'
            && typeof element.settings !== 'undefined'
            && typeof element.settings.setting !== 'undefined'
            && typeof element.settings.setting) {

          array.push(element);
        }
      })

      return array
    },
    imgSrc() {
      let string = this.$store.state.rootUrl + 'build/pix/components/areas/' + this.identifier.replaceAll('-','_');

      Object.keys(this.element.selection).forEach((key) => {
        let option = this.element.selection[key];

        string += '--' + option;
      })

      string += '.png';

      return string
    },
    imgSrcHover() {
      let string = this.$store.state.rootUrl + 'build/pix/components/areas/' + this.identifier.replaceAll('-','_');

      string += '--webview.png';

      return string
    },
  },
  methods: {
    checkIfHoverable: async function() {
      const imageUrl = this.imgSrcHover;

      try {
        const response = await fetch(imageUrl);

        if (response.ok || response.status === 200) {
          this.hoverable = true;
        } else if (response.status === 404 && this.$store.state.debug) {
          console.log('kein Bild unter folgendem Pfad gefunden:', imageUrl);
        }
      } catch (error) {
        if (this.$store.state.debug) {
          console.log ('Fehler bei der Abfrage des Screenshots:', error);
        }
      }
    },
  }
}
</script>

<style lang="less">
.hanlde {
  cursor: grab;
}

  .wireframe-img {
    max-width: 100%;
    height: auto;

    &--toolkit {
      &:hover {
        cursor: grab;
      }
    }
  }

  .wireframe-screenshot-container {
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    background: #fff;
    opacity: 0;
    transition: opacity 0.5s;

    &:hover {
      cursor: grab;
      opacity: 1;
    }
  }

  .dragdrop_handle {
    position: relative;
    z-index: 1;
  }

  .toolkit-item__title {
    font-size: 0.8rem;
    line-height: 1.3;

    .btn {
      border: 0 !important;
      color: #337ab7;
      cursor: pointer;
    }
  }
</style>
